<template>
  <div id="form-editor" class="data-list-container">
    <form @submit.prevent="saveEdit" ref="form">
      <div class="vx-col w-full mb-base">
        <vx-card collapse-action
                 title="Order"
                 title-color="primary"
                 subtitle="Edit Order Details">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input class="w-full" v-model="current_order.name" name="name" data-vv-validate-on="blur" v-validate="'required|alpha_spaces'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('name') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Email</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input class="w-full" v-model="current_order.email" name="email" data-vv-validate-on="blur" v-validate="'required|email'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('email') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Country Code</span>
            </div>
            <div class="vx-col sm:w-1/12 w-full">
              <vs-input class="w-full" v-model="current_order.country_code" name="country code" data-vv-validate-on="blur" v-validate="'required|numeric'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('country code') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Phone</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input class="w-full" v-model="current_order.phone" name='phone' data-vv-validate-on="blur" v-validate="'required|numeric'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('phone') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-input class="w-full" v-model="current_order.address" name="address" data-vv-validate-on="blur" v-validate="'required'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('address') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Postcode</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <vs-input class="w-full" v-model="current_order.postcode" name="postcode" data-vv-validate-on="blur" v-validate="'required'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('postcode') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>State Code</span>
            </div>
            <div class="vx-col sm:w-1/4 w-full">
              <v-select label="label" :options="state_codes" v-model="order_state_code" name="fulfillment type" data-vv-validate-on="blur" v-validate="'required'"/>
                <span class="text-danger text-sm float-left">{{ errors.first('state code') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Payment Status</span>
            </div>
            <div class="vx-col sm:w-1/6 w-full">
              <v-select :options="payment_status" v-model="current_order.payment_status" name="payment status" data-vv-validate-on="blur" @change="changePaymentStatus"/>
                <span class="text-danger text-sm float-left">{{ errors.first('payment status') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6" v-if="current_order.payment_status == 'Paid'">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Fulfillment</span>
            </div>
            <div class="vx-col sm:w-2/5 w-full">
              <v-select label="provider_name" :options="fulfillmentProvider" v-model="fulfillment.provider" name="fulfillment type" data-vv-validate-on="blur" />
                <span class="text-danger text-sm float-left">{{ errors.first('fulfillment type') }}</span>
            </div>
          </div>
          <div class="vx-row mb-6" v-if="showCourier">
            <div class="vx-col sm:w-1/6 w-full">
              <span>&nbsp;</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Courier</span>
                </div>
                <div class="vx-col sm:w-4/6 w-full">
                  <v-select label="name" :options="couriers" v-model="fulfillment.courier" />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>AWB</span>
                </div>
                <div class="vx-col sm:w-4/6 w-full">
                  <vs-input class="w-full" v-model="fulfillment.awb" name="awb"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/6 w-full">
                  <span>Tracking URL</span>
                </div>
                <div class="vx-col sm:w-4/6 w-full">
                  <vs-input class="w-full" v-model="fulfillment.url" name="url"/>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Custom Fields</span>
            </div>
            <div class="vx-col sm:w-5/6 w-full">
              <vs-table :data="current_order.custom_value">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Type</vs-th>
                  <vs-th>Value</vs-th>
                  <vs-th width="6em;">Action</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="tr.name">
                      {{ tr.name }}
                    </vs-td>

                    <vs-td :data="tr.type">
                      {{ tr.type }}
                    </vs-td>

                    <vs-td :data="tr.value" v-if="tr.type == 'yesno'">
                      <vs-switch v-model="tr.value" />
                    </vs-td>

                    <vs-td :data="tr.value" v-else>
                      {{ tr.value }}
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <feather-icon v-if="!tr.is_builtin" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteCustomValue(tr.name)" />
                        &nbsp;
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td>
                      <vs-input class="w-full" v-model="cur_custom_value.name" />
                    </vs-td>

                    <vs-td>
                      <v-select :options="custom_value_types" v-model="cur_custom_value.type" />
                    </vs-td>

                    <vs-td>
                      <vs-switch v-model="cur_custom_value.value" v-if="cur_custom_value.type == 'yesno'"/>
                        <flat-pickr v-model="cur_custom_value.value" :config="configdateTimePicker" placeholder="Pick a date" v-else-if="cur_custom_value.type == 'date'"/>
                          <vs-input class="w-full" v-model="cur_custom_value.value" v-else/>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <feather-icon icon="PlusSquareIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="addCustomValue()" />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </vx-card>
      </div>
    </form>
    <div class="vx-col w-full mb-base">
      <vx-card collapse-action
               title="Products"
               title-color="primary"
               subtitle="List of purchased products">

        <!--<div class="vx-row mb-6 w-2/3">-->
          <!--<div class="vx-col w-3/5">-->
            <!--<v-select label="name" :options="non_order_products" v-model="order_product" />-->
          <!--</div>-->
          <!--<div class="vx-col w-1/5">-->
            <!--<vs-button color="success" type="filled" @click.stop="addProduct">Add Product</vs-button>-->
          <!--</div>-->
        <!--</div>-->

        <vs-table :data="order_products">

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Quantity</vs-th>
            <vs-th>Price per Qty</vs-th>
            <vs-th>Discount</vs-th>
            <vs-th>Variant ID</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="tr.name">
                {{ tr.name }}
              </vs-td>

              <vs-td :data="tr.quantity">
                {{ tr.quantity }}
              </vs-td>

              <vs-td :data="tr.price_perquantity">
                {{ tr.price_perquantity}}
              </vs-td>

              <vs-td :data="tr.discount">
                {{ tr.discount}}
              </vs-td>

              <vs-td :data="tr.variant_id">
                {{ tr.variant_id}}
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div class="vx-col w-full mb-base">
        <div class="vx-row">
          <div class="vx-col ml-auto mr-auto">
            <vs-button class="mr-3 mb-2" size="large" @click.stop="saveEdit">Save</vs-button>
            <vs-button color="warning" type="border" class="mr-3 mb-2" size="large" @click.stop="cancelEdit">Cancel</vs-button>
          </div>
        </div>
    </div>
  </div>

</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import router from '@/router';
import vSelect from 'vue-select'
import axios from '@/axios';

import location from '@/services/locationService';

const dialogs = {
  invalidForm: (error) => {
    return {
      color: "danger", 
      title: "Invalid Form Specified",
      text: "Sorry, we cannot find the form you want to edit.",
      accept: () => {
        router.push('/orders');
      },
      close: () => {
        router.push('/orders');
      },
    }
  }, 

  saveFormFailed: (error) => {
    if (_.isEmpty(error)) error = "Sorry, we cannot save the form";

    return {
      color: "danger", 
      title: "Cannot Save Form",
      text: error,
      accept: () => {
        console.dir(error); // intentional for debug
      }
    }
  },

  incompleteAssets: (msg) => {
    return {
      color: "danger", 
      title: "Cannot Create Form",
      text: msg,
      accept: () => {
        router.push('/orders');
      },
      close: () => {
        router.push('/orders');
      }
    }
  }
}

const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  }
}

const layoutNames = [ 'Dropdown', 'Grid', 'Card' ];

const valid_date_or_today = (datestring) => {
  let new_date = new Date(datestring);
  return new_date === 'Invalid Date' ? new Date(): new_date; 
}

export default {

  components: {
    'v-select': vSelect,
    flatPickr,
  },

  data () {
    return {
      mode: 'create',

      order_products: [],
      order_product: {},

      current_order: {
        "id": 0,
        "form_id": 0,
        "user_id": 0,
        "name": "",
        "country_code": 0,
        "phone": 0,
        "address": "",
        "postcode": "",
        "state_code": "",
        "email": "",
        "payment_status": 0,
        "fulfillment_type": 0,
        "custom_value": [],
        "order_products": []
      },

      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i'
      },

      cur_custom_value: {
        "name": "",
        "type": "",
        "value": "",
      },

      custom_value_types: ["text", "number", "email", "date", "yesno"],

      payment_status: [ 'Canceled', 'Pending', 'Paid' ],
      fulfillment_type: [ 'Self Fulfill', 'EasyParcel', 'Other Courier' ],

      fulfillment: {
        awb: '',
        provider: {},
        courier: {},
        url: ''
      },

      state_codes: location.my_state_code,
      order_state_code: {},
    }
  },

  computed:  {

    available_products() {
      return this.$store.state.product.products;
    },

    non_order_products() {
      let ids = this.order_products.map((x) => x.id);
      return this.available_products.filter(x => ids.indexOf(x.id) < 0);
    },

    fulfillmentProvider () {
      return this.$store.state.fulfillment.organization_providers;
    },

    couriers () {
      return this.$store.state.fulfillment.couriers;
    },

    showCourier () {
      if (!this.fulfillment.provider) return false;
      return this.fulfillment.provider.fullfillment_provider_id === 1;
    },

  },

  methods: {

    addUser() {
      if (_.isEmpty(this.selected_user)) return;
      this.selected_users.push(this.selected_user);
      this.selected_user = {};
    },

    addProduct() {
      if (_.isEmpty(this.order_product)) return;
      this.order_products.push(this.order_product);
      this.order_product = {};
    },

    deleteUser(user_id) {
      this.selected_users = this.selected_users.filter(x => x.id !== user_id);
    },

    deleteProduct(product_id) {
      this.order_products = this.order_products.filter(x => x.id !== product_id);
    },

    addCustomValue() {
      if (this.cur_custom_value.name.trim() == "" || this.cur_custom_value.type.trim() == '""') {
        this.$vs.notify(notifs.error("Please make sure you have entered name and field type."));
        return;
      }

      let existing = this.current_order.custom_value.filter(x => {
        return x.name.toLowerCase().trim() === this.cur_custom_value.name.toLowerCase().trim();
      })

      if (existing.length > 0) {
        this.$vs.notify(notifs.error(`'${this.cur_custom_value.name}' field already added`));
        return;
      }

      this.current_order.custom_value.push(Object.assign({}, this.cur_custom_value));
      this.cur_custom_value.name = "";
      this.cur_custom_value.type = "";
      this.cur_custom_value.value = "";
      this.$vs.notify(notifs.success("Custom value added"));
    },

    deleteCustomValue(name) {
      this.current_order.custom_value = this.current_order.custom_value.filter(x => x.name !== name);
    },

    async saveEdit() {
      if (this.errors.any()) {
        this.$vs.notify(notifs.error("Please input the form correctly"));
        return;
      }

      let user = await this.$store.getters['user/user'];
      let the_order = Object.assign({}, this.current_order);

      the_order.user_id = user.id;
      the_order.fulfillment_type = this.fulfillment_type.indexOf(the_order.fulfillment_type);
      the_order.status = this.payment_status.indexOf(the_order.payment_status);
      the_order.state_code = this.order_state_code.value || '';

      if (the_order.order_products.length === 0) {
        this.$vs.dialog(dialogs.saveFormFailed("Form must have at least one product"));
        return;
      }

      // save fulfillment first
      if (typeof this.fulfillment.provider !== 'undefined' && typeof this.fulfillment.courier !== 'undefined')  {
        let fulfillment = this.$store.dispatch('order/updateFulfillment', 
          {
            order:  the_order,
            fulfillment: JSON.parse(JSON.stringify(this.fulfillment))
          }
        );
      }

      try {
        let action = this.mode === 'create' ? 'order/createOrder':'order/updateOrder';
        await this.$store.dispatch(action, the_order);
        router.push('/orders');
      } catch (e) {
        this.$vs.dialog(dialogs.saveFormFailed(e));
      }
    }, 

    cancelEdit (){
      router.push('/orders');
    },

    changePaymentStatus() {
      this.current_order.fulfillment_type = 0;
    }
  },

  async mounted () {
    console.dir(this.$route.params.order_id);
    if (!this.$route.params.order_id.toString().trim().match(/^QS\-[A-Za-z0-9]+$/) && this.$route.params.order_id !== 'new') {
      this.mode = 'invalid';
      this.$vs.dialog(dialogs.invalidForm());
      return;
    }

    if (this.$route.params.order_id === 'new') {
      this.mode = 'create';
    } else {
      this.mode = 'edit';
    }

    let result = await Promise.all([
      this.$store.dispatch('fulfillment/getCouriers'),
      this.$store.dispatch('fulfillment/getOrganizationProvider', this.$store.state.user.current_organization),
      this.$store.dispatch('fulfillment/getProviders')
    ]).then((res)=> {})
      .catch((e) => {
        console.log(e);
    });

    try {
      await this.$store.dispatch('product/getProducts');
    } catch (e) {
      this.$vs.dialog(dialogs.incompleteAssets("This organization doesn't have any products yet"));
      return;
    }

    if (this.mode !== 'edit') {
      return;
    }

    try {
      await this.$store.dispatch('order/getOrder', this.$route.params.order_id);
    } catch (e) {
      console.log(e);
      this.$vs.dialog(dialogs.invalidForm(e));
      return;
    }

    //// loading current form
    let ref_products = this.available_products.reduce((dic, cur, idx) => {
      dic[cur.id] = idx;
      return dic;
    }, {});

    let the_order = JSON.parse(JSON.stringify(this.$store.state.order.current_order));
    this.order_state_code = this.state_codes.find(x => x.value.toLowerCase() === (the_order.state_code || '').toLowerCase()) || {};
    for (let key in the_order) {
      if (key === 'order_products') {
        for (let prd of the_order.order_products) {
          this.order_products.push(prd);
          continue;
        }
      }

      if (key === 'fulfillment_type') {
        this.current_order.fulfillment_type = this.fulfillment_type[the_order[key]];
        continue;
      }

      if (key === 'status') {
        this.current_order.payment_status = this.payment_status[the_order[key]];
        continue;
      }

      this.current_order[key] = the_order[key];
    }
    /// bind fulfillment
    this.fulfillment.awb = the_order.awb;
    this.fulfillment.url = the_order.tracking_url;
    this.fulfillment.courier = this.couriers.find((x) => x.name === the_order.courier_name);
    this.fulfillment.provider = this.fulfillmentProvider.find((x) => x.id === the_order.organization_fulfillment_provider_id);
  },
}
</script>

<style lang="scss">
#form-editor {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>


